import axios from "axios"
import config from "../../config"

export default {
  namespaced: true,
  state: {
    sheetContentPages: null,
    usedItems: null,
    enableItems:null,
    duplicatedAnswers: null,
    alertMessage: null,
    contentTotalScores: [],
  },

  getters: {
    graphDatas: (state, getters, rootState) => {

      function convertToGraphData(arrays, type) {
        // 2次元配列を１次元配列に変換
        const simpleArr = arrays.reduce((pre,current) => {
          pre.push(...current)
          return pre
        },[])
        // 配列要素の総数を取得(分母用)
        const totalContentNum = simpleArr.length

        // typeに応じて使用するマスターデータを設定
        let masterData = []
        if(type === 'question') {
          masterData = rootState.master.allQuestionTypes
        } else if(type === 'answer') {
          masterData = rootState.master.allAnswerFormats
        } else if(type === 'point') {
          masterData = rootState.master.allPoints
        } else if(type === 'material') {
          masterData = rootState.master.allMaterials.filter(x=> x.subject_id === rootState.top.selectedSubject.id)
        } else if(type === 'kind') {
          masterData = rootState.master.allMaterialKinds
        }

        // 集計し、表示用に整形
        const formatedGraphData = masterData.map(x => {
          const count = simpleArr.filter(y => y == x.id).length
          return{
            name: x.name,
            data: count > 0 ? [Math.floor( count / totalContentNum * 100 )] : [0] // 小数点以下切り捨てて割合の算出（判例表示用にcount=0もデータに格納する）
          }
        })
        return formatedGraphData
      }

      //stateから各グラフ表示用データを取得
      const questionTypeIds = state.usedItems.map(x => x.questionTypeIds)
      const answerTypeIds   = state.usedItems.map(x => x.answerTypeIds)
      const pointIds        = state.usedItems.map(x => x.pointIds)
      const materialKindIds = state.usedItems.map(x => x.materialKinds)
      const materialIds     = state.usedItems.map(x => x.materialIds)

      return [
        {
          categories: ['問題種類'],
          series: convertToGraphData(questionTypeIds, 'question')
        },
        {
          categories: ['解答形式'],
          series: convertToGraphData(answerTypeIds, 'answer')
        },
        {
          categories: ['観点'],
          series: convertToGraphData(pointIds, 'point')
        },
        {
          categories: ['教材種類'],
          series: convertToGraphData(materialKindIds, 'kind')
        },
        {
          categories: ['新学社教材'],
          series: convertToGraphData(materialIds, 'material')
        },
      ]
    },

    // 配点用配列を整形する
    contentTotalScores(state) {
      let contentTotalScores = []
      state.usedItems.map((item,itemIndex) => {
        let contentTotalScore = 0
        contentTotalScores[itemIndex+1] = []
        item.sheetQuestions.map((question,questionIndex) => {
          contentTotalScores[itemIndex+1][questionIndex+1] = question.allot
          contentTotalScore += Number(question.allot) //入力値は文字列で渡ってきている
        })
        contentTotalScores[itemIndex+1]['total'] = contentTotalScore
      })
      return contentTotalScores
    },
  },

  mutations: {
    setSheetContentPages(state, payload) {
      state.sheetContentPages = payload.sheetContentPages
    },
    setUsedItems(state, payload) {
      state.usedItems = payload.usedItems
    },
    setEnableItems(state, payload) {
      state.enableItems = payload.enableItems
    },
    setSheetSearchCondition(state, payload) {
      state.sheetSearchCondition = payload.sheetSearchCondition
    },
    setSplicedUsedItems(state, payload) {
      // 削除ボタンクリックで実行される大問削除メソッド
      state.usedItems.splice(payload.targetIndex, 1)
    },
    setReplacedUsedItems(state, payload) {

      let targetPartNo = payload.targetPartNo
      let targetIndex  = payload.targetIndex
      let replaceFlg   = false
      if(payload.mode === 'addPrev') {         // １つ上に追加
        // targetPartNoはそのままでOK
        // 出題する問題に追加後、候補問題から削除
        state.enableItems.splice(targetIndex, 1)
      } else if(payload.mode === 'addNext') {  // １つ下に追加
        targetPartNo++
        // 出題する問題に追加後、候補問題から削除
        state.enableItems.splice(targetIndex, 1)
      } else if(payload.mode === 'change') {   // 差し替える
        replaceFlg = true
        // 出題する問題と候補問題を差し替える
        state.enableItems.splice(targetIndex, replaceFlg, state.usedItems[targetPartNo])
      }
      // 出題する問題に対して差し替え・追加処理
      state.usedItems.splice(targetPartNo, replaceFlg, payload.replaceContent)

      // 解答重複チェック(数学の場合はチェックしない)
      state.alertMessage = ''
      state.duplicatedAnswers = []
      if(payload.selectedSubjectCode !== config.SUGAKU) {
        state.usedItems.map(item => {
          payload.replaceContent.answers.map(answer => {
            if(item.answers.includes(answer)) {
              state.duplicatedAnswers.push({
                contentId: item.id,
                replaceContentId: payload.replaceContent.id,
                answer: answer
              })
            }
          })
        })
        // エラーメッセージ生成
        state.duplicatedAnswers.map(x => {
          state.usedItems.map((val,key) => {
            if(val.id === x.contentId) {
              x.partNo = key+1        // 大問番号を取得
            } else if(val.id === x.replaceContentId) {
              x.replacePartNo = key+1 // 大問番号を取得
            }
          })
          if(x.partNo && x.replacePartNo) {
            const partNoA = x.partNo < x.replacePartNo ? x.partNo : x.replacePartNo
            const partNoB = x.partNo > x.replacePartNo ? x.partNo : x.replacePartNo
            state.alertMessage += '大問'+partNoA+' と 大問'+partNoB+' で 解答：【'+ x.answer + '】 が重複しています。\n'
          }
        })
      }
    },
    // 配点や観点の変更を反映する
    setChangedItems(state, payload) {
      //対象大問のコピーを作成
      const replaceContent = state.usedItems[payload.targetItemIndex]
      //その大問の対象小問の設定を変更
      if(payload.mode === 'score') {
        replaceContent.sheetQuestions[payload.targetQuestionIndex].allot   = payload.changedAllot
      } else if(payload.mode === 'viewPoint') {
        replaceContent.sheetQuestions[payload.targetQuestionIndex].pointId = payload.changedPointId //グラフ表示には不要だが、テスト登録・更新時に必要
        replaceContent.pointIds[payload.targetQuestionIndex]               = payload.changedPointId //グラフ更新用
      }
      //対象大問を配点や観点変更後のデータを差し替える（これでグラフ自動反映される）
      state.usedItems.splice(payload.targetItemIndex, 1, replaceContent)
    },
  },

  actions: {
    async getSheetContents({commit}, params) {
      const res = await axios.post('/api/v1/teacher/sheets', params)
      commit('setSheetContentPages', {
        sheetContentPages: res.data
      })
      // レスポンスから表示用に整形
      const contentPages = []
      const sheetContentPages = res.data.sheet_content_pages
      Object.entries(sheetContentPages).map(item => {
        contentPages.push({
          // コンテンツ単位の表示用
          id:              Number(item[1].content_page.content.id),
          pageRange:       item[1].content_page.start_page + '~' + item[1].content_page.end_page + 'p',
          questionCnt:     item[1].content_page.content.question_cnt,
          usedTime:        item[1].content_page.content.used_cnt,
          material:        item[1].content_page.content.materials.map(material => material.name).join(', '),
          // 大問プレビュー用
          questionImage:   item[1].content_page.content.question_image_url,
          answerImage:     item[1].content_page.content.answer_image_url,
          // グラフ整形用
          chapterName:     item[1].content_page.content.chapter_name,
          questionTypeIds: item[1].content_page.content.questions.map(question => question.question_type_id),
          answerTypeIds:   item[1].content_page.content.questions.map(question => question.answer_format_id),
          pointIds:        item[1].sheet_questions.map(sheet_question => sheet_question.point_id),// pointIdsだけはsheet_questionsの値を参照する（観点変更後、再開することもあるから）
          materialKinds:   item[1].content_page.content.materials.map(material => material.kind),
          materialIds:     item[1].content_page.content.materials.map(material => material.id),
          // 解答重複チェック用
          answers:         item[1].content_page.content.questions.map(question => question.answer),
          // 更新用
          number:          item[1].number,
          //contentPageId:   item[1],
          sheetQuestions:  item[1].sheet_questions.map(sheet_question => {
            return {
              id:         sheet_question.id,
              questionId: sheet_question.question_id,
              number:     sheet_question.number,
              allot:      sheet_question.allot,
              pointId:    sheet_question.point_id
            }
          }),
        })
      })
      commit('setUsedItems', {
        usedItems: contentPages
      })
    },
    // 途中保存処理
    async updateSheetStatus({state}, params) {
      const targetSheetId = state.sheetContentPages.id
      const res = await axios.put('/api/v1/teacher/sheets/' + targetSheetId, params)
      //TODO:保存するstepによってメッセージを分ける
      let message = ''
      if(res.status !== 200) {
        message = 'テストの保存に失敗しました。'
      } else {
        message = 'テストを保存しました。'
      }
      return {message: message }
    },
  },
}
